import { render, staticRenderFns } from "./Mtyj.vue?vue&type=template&id=87c895e0&scoped=true&"
import script from "./Mtyj.vue?vue&type=script&lang=js&"
export * from "./Mtyj.vue?vue&type=script&lang=js&"
import style0 from "./Mtyj.vue?vue&type=style&index=0&id=87c895e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c895e0",
  null
  
)

export default component.exports